import { useTranslation } from "react-i18next";
import PageWrapper from 'components/page/PageWrapper';

import SlideUp from "components/animation/SlideUp";

import bg from 'assets/images/banner/banner01.jpg';
import img from 'assets/images/corporation/ceo_message_01.jpg';

export default function Greetings(){
  const {t} = useTranslation();
  const menuName= t('menu.sub-greetings');
  const path=[{url:'/corporation', name:t('menu.main-about')}, {url:'/corporation/greetings', name:menuName}];
  const title = t('greetings.banner.title')
  const comment = t('greetings.banner.comment')

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className={`flex flex-col lg:flex-row items-center lg:justify-center mb-20` }>
        <div className="lg:w-[553px] w-[348px] lg:pr-20">
          <SlideUp>
          <p className="mb-10 text-2xl font-semibold lg:text-4xl">{t('greetings.body.title')}</p>
          </SlideUp>
          <p className="mb-10 font-semibold lg:text-lg">{t('greetings.body.sub-title')}</p>
          {[1, 2, 3, 4].map(i=>{
            return (
            <p key={i} className="mb-10 text-xs text-gray-700 lg:text-lg">{t(`greetings.body.comment-${i}`)}</p>
            );
          })}
        </div>
        <SlideUp>
        <div className="lg:w-[553px] lg:h-[641px] w-[348px] h-[312px] bg-cover"
          style={{backgroundImage:`url(${img})`}}>
        </div>
        </SlideUp>
      </div>
    </PageWrapper>
  );
}